<script>
  import { _ } from '@sveltia/i18n';
  import { FORMAT_TEXT_COMMAND } from 'lexical';
  import { getContext } from 'svelte';
  import Button from '../../button/button.svelte';
  import Icon from '../../icon/icon.svelte';
  import { AVAILABLE_BUTTONS } from '../constants.js';
  import { focusEditor } from '../core.js';

  /**
   * @import { TextEditorFormatType, TextEditorStore } from '../../../typedefs';
   */

  /**
   * @typedef {object} Props
   * @property {TextEditorFormatType} type Button type.
   */

  /**
   * @type {Props & Record<string, any>}
   */
  let {
    /* eslint-disable prefer-const */
    type,
    /* eslint-enable prefer-const */
  } = $props();

  /** @type {TextEditorStore} */
  const editorStore = getContext('editorStore');
  const selectionTypeMatches = $derived(editorStore.selection.inlineTypes.includes(type));
</script>

<Button
  iconic
  aria-label={_(`_sui.text_editor.${AVAILABLE_BUTTONS[type].labelKey}`)}
  aria-controls="{editorStore.editorId}-lexical-root"
  disabled={!editorStore.useRichText}
  pressed={selectionTypeMatches}
  onclick={async () => {
    if (editorStore.editor) {
      await focusEditor(editorStore.editor);
      editorStore.editor.dispatchCommand(FORMAT_TEXT_COMMAND, type);
    }
  }}
>
  {#snippet startIcon()}
    <Icon name={AVAILABLE_BUTTONS[type].icon} />
  {/snippet}
</Button>
